class loginCtrl {
    /**
     * 模块只负责用户登陆
     * 登陆后只会被重定向到 /home/admin  或/user
     * 之前或之后的控制逻辑通常由 mainCtrl 负责
     *
     */
    constructor($scope, httpRequest, sweetalert, $rootScope, $http, $timeout, $uibModalStack, $cacheFactory) {
        $scope.logging = false
        window.layer.closeAll()
        $uibModalStack.dismissAll()
        $scope.autoHeightConfig = {
            headerHeight: 0,
            footerHeight: 60,
        }
        let logining = false
        // 是否登录失败 失败则显示验证码
        $scope.loginError = false

        function checkForm(loginForm, showCode) {
            if (!loginForm.userName) {
                return '账号不能为空'
            }
            if (!loginForm.misi) {
                return '密码不能为空'
            }
            if (showCode && !loginForm.codeValue) {
                return '验证码不能为空'
            }
            return ''
        }
        // 提交用户登陆
        $scope.submitForm = function submitForm(event) {
            event.preventDefault()
            if (logining) {
                return
            }
            logining = true

            // 临时解决360保存密码问题
            $scope.loginUserInfo.userName = document.loginForm.username.value
            $scope.loginUserInfo.misi = document.loginForm.misi.value
            $timeout(() => {
                $scope.loginError = checkForm($scope.loginUserInfo, $scope.loginError)
                if (!$scope.loginError) {
                    httpRequest.post_checkUserLogin($scope.loginUserInfo).then((res) => {
                        if (res.data.value) {
                            sweetalert.confirm('登陆提醒', '该账号已登陆，是否继续？').then(
                                () => {
                                    loginFat()
                                },
                                () => {
                                    logining = false
                                }
                            )
                        } else {
                            loginFat()
                        }
                    })
                } else {
                    logining = false
                }
            })
        }

        async function getSysOrganizationInfoList() {
            httpRequest.post_getSysOrganizationInfoList(item.orgOwnership).then((res) => {
                localStorage.setItem('organizationInfoList', JSON.stringify(res.data.value))

                // JSON.stringify({
                //     deviceType: $scope.deviceType,
                //     deviceTypeName: $scope.deviceTypeName,
                //   })
            })
        }
        function loginFat() {
            localStorage.clear()
            localStorage.eVersion = eVersion
            $http.post(`${host.etcloud}auth/login/loginFat`, $scope.loginUserInfo).then(
                (res) => {
                    const loginResponse = res.data.value
                    if (res.data.success) {
                        //   getSysOrganizationInfoList()
                        const roleIdList = loginResponse.loginInfo.user.roleIdList
                        const roleList = loginResponse.loginInfo.user.roleList
                        $rootScope.userRoleIdList = roleIdList
                        $rootScope.userRoleList = roleList
                        $rootScope.loginOrgList = loginResponse.loginInfo.orgList //放顶层作用域,先不缓存
                        loginResponse.loginInfo.user.roleIdList = []
                        loginResponse.loginInfo.user.roleList = []
                        loginResponse.loginInfo.orgList = []
                        localStorage.setItem('function_list', JSON.stringify(loginResponse.functionList))
                        localStorage.setItem('user_info', JSON.stringify(loginResponse.loginInfo))
                        localStorage.setItem('id_token', loginResponse.accessToken.accessToken)
                        $rootScope.$broadcast('logIn', true)
                        $scope.$emit('logoChange')
                    } else {
                        $scope.loginError = res.data.message
                        $scope.freshCode()
                    }
                    logining = false
                },
                () => {
                    logining = false
                    $scope.freshCode()
                    $scope.loginError = '系统忙，请稍后再试'
                }
            )
        }
        // 过滤机构list属性为null 只拿有用的信息
        function institutionsOfUsefulInfor(obj) {
            const { orgList } = obj.loginInfo
            let newOrgList = []
            orgList.forEach((el) => {
                const { orgId, orgName, treeLevelCode, saleId, saleCreditCode, parentOrgId } = el
                newOrgList.push({
                    orgId,
                    orgName,
                    treeLevelCode,
                    saleId,
                    saleCreditCode,
                    parentOrgId,
                })
            })
            obj.loginInfo.orgList = newOrgList
            return obj
        }
        $scope.freshCode = function freshCode() {
            httpRequest.getfreshCode().then((res) => {
                $scope.verifiedcodeUrl = res.data.value.codeImage
                $scope.loginUserInfo.codeId = res.data.value.codeId
            })
        }
        httpRequest.get_getSoftwareVersion().then((res) => {
            $scope.version = res.data.value.version
            $scope.softwareInstallUrl = res.data.value.software.install_url
            const time = res.data.value.time || ''
            $scope.versionTime = `${time[0] + time[1] + time[2] + time[3]}-${time[4]}${time[5]}-${time[6]}${time[7]}`
        })
        $('html').addClass('et-overflow-hidden')
        $scope.$on('$stateChangeStart', () => {
            $('html').removeClass('et-overflow-hidden')
        })
    }
}
loginCtrl.$inject = ['$scope', 'httpRequest', 'sweetalert', '$rootScope', '$http', '$timeout', '$uibModalStack', '$cacheFactory']
export default loginCtrl



// WEBPACK FOOTER //
// ./src/app/main/login/loginCtrl.js